// extracted by mini-css-extract-plugin
module.exports = {"c-select-with-search__user-groups":"UserUpdateInGroup_c-select-with-search__user-groups__fg71I"};